module.exports = __webpack_public_path__ + "static/slack-f2143777917ba08d9244620295e2b480.png";